// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b7107d35","453":"5d352420"}[chunkId] + ".chunk.js";
};